export default __webpack_public_path__ + "static/media/credit.b4db191b.svg";